function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.5 21C29.67 21 29 20.32 29 19.5C29 18.67 29.67 18 30.5 18C31.32 18 32 18.67 32 19.5C32 20.32 31.32 21 30.5 21ZM29.5 13C25.36 13 22 16.36 22 20.5C22 21.58 22.22 22.63 22.68 23.61L13.14 33.14H13.13C13.03 33.23 12.98 33.36 12.98 33.49V35.49C12.98 35.7 13.11 35.89 13.32 35.96L16.32 36.96C16.58 37.04 16.86 36.9 16.95 36.64L17.87 33.87L20.63 32.94H20.62C20.76 32.89 20.88 32.77 20.93 32.62L21.86 29.81L26.655 27.41C27.545 27.77 28.485 27.95 29.445 27.95C33.575 27.95 36.945 24.58 36.945 20.45C36.945 16.31 33.575 12.95 29.445 12.95"
});

function SvgIc5D5F94B4Fc0611Eb9A030242Ac130003(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc5D5F94B4Fc0611Eb9A030242Ac130003);
export default ForwardRef;